import { render, staticRenderFns } from "./LiveItem.vue?vue&type=template&id=409f4633&scoped=true&lang=pug&"
import script from "./LiveItem.vue?vue&type=script&lang=js&"
export * from "./LiveItem.vue?vue&type=script&lang=js&"
import style0 from "./LiveItem.scss?vue&type=style&index=0&id=409f4633&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409f4633",
  null
  
)

export default component.exports